import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService, AvailableLanguage } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnDestroy {

  currentLanguage: string = 'en';
  languages: AvailableLanguage[] = [];

  private subscription: Subscription;

  constructor(private languageService: LanguageService) {
    this.languages = this.languageService.getAvailableLanguages();
    this.subscription = this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }

  get currentLabel(): string {
    const found = this.languages.find(l => l.code === this.currentLanguage);
    return found ? found.label : 'EN';
  }

  selectLanguage(langCode: string): void {
    this.languageService.setLanguage(langCode);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
